export default "__VITE_ASSET__BpdlX9RA__"